import { BrandStyles, RecognizedBrands } from '@dap/common/types';
import { brandStylesConfig } from './brandStylesConfig';

export function getBrandStyle(brandKey?: string | null): BrandStyles {
  if (!brandKey) {
    return brandStylesConfig.default;
  }

  return brandStylesConfig[brandKey as RecognizedBrands] || brandStylesConfig.default;
}
